import { get } from '../Services/http.js';
export function myPagesFilterWrapper(url) {
    var dropDownContainer = document.getElementById("js-filter-dropdown-container");
    var numberInput = document.getElementById("js-fliter-numberinput");
    var filteredItems = [];
    var allItems;

    get(url).then(res => {
        res
            .json()
            .then(data => {
                allItems = data;
            })
    })
    .catch(error => {
        console.error("Filter API call Failed");
    });

    numberInput.addEventListener("input", event => {
        filteredItems = allItems.filter(x => x.startsWith(event.target.value));
        dropDownContainer.innerHTML = "";
        dropDownContainer.style.display = event.target.value == "" || filteredItems.length == 0 ? "none" :"block";

        for(var item of filteredItems) {
            var p = document.createElement("p");
            p.innerHTML = item;
            p.addEventListener("click", addItem)
            dropDownContainer.append(p)
        }
    });
  
    function addItem(event) {
        numberInput.value = event.target.innerHTML;
        dropDownContainer.style.display = "none";
    }
}
